import * as React from 'react';
import clsx from 'clsx';
import { PlayIcon } from '@heroicons/react/24/solid';
import { MockWaveform } from './MockWaveform';
import greenMicrophoneIcon from '@/assets/images/svg/green_microphone_icon.svg';
import noEcho from '@/assets/images/echo/no_echo.webp';
import { EchoAvatar } from '@/components/common/EchoAvatar';

interface MockUserAudioBubbleProps {
  avatarSrc?: string;
  compact?: boolean;
  className?: string;
}

export const MockUserAudioBubble: React.FC<MockUserAudioBubbleProps> = ({
  avatarSrc = noEcho,
  compact,
  className,
}) => (
  <div className={clsx('flex w-full items-end justify-end', className)}>
    <div
      className={clsx(
        'relative flex items-center',
        compact ? 'min-w-[240px] max-w-[360px] gap-3' : 'min-w-[300px] max-w-[420px] gap-4',
        'rounded-24',
        compact ? 'p-2 pr-4' : 'p-3 pr-6',
        'bg-user-bubble-gradient text-white shadow-md'
      )}
    >
      {/* Avatar + Mic badge */}
      <div className='relative shrink-0'>
        <EchoAvatar src={avatarSrc} size={48} />
        <img
          src={greenMicrophoneIcon}
          alt='Voice Message'
          className='absolute -bottom-1 -right-1 h-[17px] w-[11.77px]'
        />
      </div>

      {/* Mock Waveform Player Structure - Centered */}
      <div className='relative flex min-w-0 flex-1 items-center justify-center'>
        <div className='flex w-full items-center gap-3'>
          <button className='shrink-0 text-accent-300 transition-colors hover:text-white'>
            <PlayIcon className='size-8' />
          </button>
          <div className='flex flex-1 justify-center'>
            <MockWaveform waveColor='bg-white' progressColor='bg-accent-300' />
          </div>
        </div>
      </div>
    </div>
  </div>
);
